const FilterIconMobile = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='17' height='16' viewBox='0 0 17 16' fill='none'>
      <path
        d='M4.5 8H12.5M2.5 4H14.5M6.5 12H10.5'
        stroke='#515151'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

const ActiveFilterIconMobile = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M4 8H12M2 4H14M6 12H10'
        stroke='#1C70EE'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

const CloseIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        d='M18.3636 7.05025C18.7541 6.65972 18.7541 6.02656 18.3636 5.63603C17.9731 5.24551 17.3399 5.24551 16.9494 5.63603L11.9996 10.5858L7.04988 5.63603C6.65936 5.24551 6.02619 5.24551 5.63567 5.63603C5.24514 6.02656 5.24514 6.65972 5.63567 7.05025L10.5854 12L5.63567 16.9497C5.24514 17.3403 5.24514 17.9734 5.63567 18.364C6.02619 18.7545 6.65936 18.7545 7.04988 18.364L11.9996 13.4142L16.9494 18.364C17.3399 18.7545 17.9731 18.7545 18.3636 18.364C18.7541 17.9734 18.7541 17.3403 18.3636 16.9497L13.4138 12L18.3636 7.05025Z'
        fill='#4B4C4D'
      />
    </svg>
  );
};

const ClearAllIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.2339 5.29517C11.5017 3.31113 8.55427 2.76184 6.18722 4.12845C4.56837 5.0631 3.5894 6.68031 3.40533 8.40961C3.36148 8.8215 2.99204 9.11985 2.58016 9.07601C2.16827 9.03217 1.86991 8.66273 1.91375 8.25084C2.14639 6.0653 3.3856 4.01392 5.43722 2.82942C8.53385 1.04157 12.4147 1.8424 14.5739 4.56047L14.6554 4.25636C14.7626 3.85627 15.1738 3.61883 15.5739 3.72603C15.974 3.83324 16.2115 4.24449 16.1043 4.64459L15.5552 6.69363C15.5037 6.88577 15.378 7.04958 15.2058 7.14904C15.0335 7.24849 14.8288 7.27544 14.6367 7.22396L12.5876 6.67492C12.1875 6.56772 11.9501 6.15646 12.0573 5.75636C12.1645 5.35626 12.5757 5.11883 12.9758 5.22603L13.2339 5.29517ZM15.4191 8.92397C15.8309 8.96781 16.1293 9.33725 16.0855 9.74914C15.8528 11.9347 14.6136 13.9861 12.562 15.1706C9.46551 16.9583 5.58489 16.1577 3.42564 13.4399L3.34426 13.7436C3.23705 14.1437 2.8258 14.3812 2.4257 14.274C2.0256 14.1668 1.78816 13.7555 1.89537 13.3554L2.44441 11.3064C2.55162 10.9063 2.96287 10.6688 3.36297 10.776L5.41201 11.3251C5.8121 11.4323 6.04954 11.8435 5.94234 12.2436C5.83513 12.6437 5.42388 12.8812 5.02378 12.774L4.76523 12.7047C6.49736 14.6888 9.44489 15.2382 11.812 13.8715C13.4308 12.9369 14.4098 11.3197 14.5939 9.59037C14.6377 9.17849 15.0072 8.88013 15.4191 8.92397Z'
        fill='#111212'
      />
    </svg>
  );
};

const MoreIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='15' height='14' viewBox='0 0 15 14' fill='none'>
      <path
        d='M3.70801 7H10.708M1.95801 3.5H12.458M5.45801 10.5H8.95801'
        stroke='#111212'
        strokeWidth='1.16667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export { FilterIconMobile, CloseIcon, ActiveFilterIconMobile, ClearAllIcon, MoreIcon };
